import connectAutocomplete from "instantsearch.js/es/connectors/autocomplete/connectAutocomplete.js";
import { useConnector } from "../hooks/useConnector.js";
export function useAutocomplete(props, additionalWidgetProperties) {
  return useConnector(connectAutocomplete, props, additionalWidgetProperties);
}